import Ajax from '../../global/od/Ajax';

export default class optionalReferenceChange {
	constructor() {
		this.inputField = $('#purchaseOrder');
		// Get language code from window.od object and append to request path
		let languageCode = '/';
		if (window.od && window.od.config && window.od.config.language) {
			languageCode = `/${window.od.config.language.substring(0, 2)}`;
			languageCode.toLowerCase();
		}
		this.url = `${languageCode}/checkout/multi/review/optionalReference/save`;

		if (this.inputField) {
			this.inputField.on('blur', () => this.submitPONumber());
		}
	}

	submitPONumber() {
		const purchaseOrderValue = this.inputField.val();
		const purchaseOrderMinLength = 1;
		const purchaseOrderMaxLength = 30;
		const postData = {
			purchaseOrder: purchaseOrderValue,
		};

		if (
			purchaseOrderValue.length < purchaseOrderMinLength ||
			purchaseOrderValue.length > purchaseOrderMaxLength
		) {
			return;
		}

		Ajax.post(this.url, postData)
			.then(() => {})
			.catch(() => {});
	}
}
